import type { ICampaignManagementCampaign } from '@/Interfaces/CampaignManagement/Campaign.interface';
import { buildCampaignExportData } from '@/helpers/campaignManagement/campaignExport';
import { downloadCampaignExport } from '@/helpers/campaignManagement/campaignExportCsv';
import { useAppSelector } from '@/store/hooks';
import { selectShowBidCpmControl } from '@/store/selectors/currentWhitelabel.selectors';
import * as Sentry from '@sentry/react';
import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';

export const useCampaignExport = (campaign?: ICampaignManagementCampaign | null) => {
  const showBidCpm = useAppSelector(selectShowBidCpmControl);

  const canExport = useMemo(
    () => !!campaign?.lineItems?.some(({ is_archived }) => !is_archived),
    [campaign?.lineItems],
  );

  const exportCampaign = useCallback(() => {
    if (!campaign) {
      return;
    }

    try {
      downloadCampaignExport(buildCampaignExportData(campaign, { showBidCpm }));
    } catch (error) {
      Sentry.captureException(error, { extra: { campaignId: campaign.id } });
      toast.error('Failed to export Campaign. Please try again.');
    }
  }, [campaign, showBidCpm]);

  return { exportCampaign, canExport };
};
